//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export class ContactCard
{
	public name: string;
	public address: string;
	public postalAddressAsSameAsVisitingAddress: boolean;
	public phoneNumbersAnchors: string;
	public emailAnchor: string;
	public homePageAnchor: string;
	public visitingAddress: Address;
	public postalAddress: Address;
}
export class LatLong
{
	public latitude: number;
	public longitude: number;
}
export class ProjectListMapItem
{
	public position: LatLong;
	public friendlyPosition: string;
	public imageSrcUrl: string;
	public dateAndPlace: string;
	public title: string;
	public description: string;
	public contentLinkId: number;
	public contentGuid: string;
	public contentUrl: string;
	public pageIsDisabled: boolean;
}
export class ProjectListMapBase
{
	public mapItems: ProjectListMapItem[];
}
export class ProjectListPageMap extends ProjectListMapBase
{
	public pageGuid: string;
	public filterCategories: FilterCategories;
}
export class ProjectListPageSearchHit
{
	public contentLinkId: number;
	public pageIsDisabled: boolean;
}
export class ProjectListPageSearchResults
{
	public pageGuid: string;
	public isPaginated: boolean;
	public paginationPage: number;
	public paginationSize: number;
	public paginationPageCount: number;
	public totalMatching: number;
	public paginationTranslation: PaginationTextTranslation;
	public pageSearchHitsCount: number;
	public requestedFilterCatIDs: number[];
	public requestedSearchFor: string;
	public pageSearchHits: ProjectListPageSearchHit[];
}
export class PaginationTextTranslation
{
	public forNext: string;
	public forPrevious: string;
	public forOf: string;
}
export class FilterCategories
{
	public categories: FilterCategory[];
}
export class FilterCategory
{
	public notTranslatedName: string;
	public name: string;
	public id: number;
	public isTopCategoryInFilter: boolean;
	public isAllWithin: boolean;
	public categories: FilterCategory[];
}
export class FeaturedProjectMap extends ProjectListMapBase
{
	public featuredProjectPageGuid: string;
	public featuredProjectPageId: number;
}
export class ContactCardMapItem
{
	public contentLinkId: number;
	public selected: boolean;
	public contactCard: ContactCard;
	public position: LatLong;
	public friendlyPosition: string;
	public googleMapsLink: string;
	public googleMapsLinkText: string;
	public visitingAddressText: string;
	public postalAddressText: string;
}
export class ContactCardMap
{
	public selectedContentLinkId: number;
	public mapItems: ContactCardMapItem[];
}
export class Address
{
	public line1: string;
	public line2: string;
}
export enum MapEndpointType {
	ProjectPageContactCardMap = 0,
	ProjectListPageMap = 1,
	FeaturedProjectMap = 2,
	ContactCardMap = 3
}
export class MapRequest
{
	public culture: number;
	public contentLinkId: number;
	public contentGuid: string;
	public mapEndpoint: string;
	public searchEndpointBase: string;
	public endpointType: MapEndpointType;
}
